export default {
  blanck: {
    rows: 5,
    cols: 15,
    rects: [],
  },
  clover: {
    rows: 4,
    cols: 12,
    rects: [
      { left: 0, top: 0, width: 1, height: 1, label: '⎋' },
      { left: 1, top: 0, width: 1, height: 1, label: 'Q' },
      { left: 2, top: 0, width: 1, height: 1, label: 'W' },
      { left: 3, top: 0, width: 1, height: 1, label: 'E' },
      { left: 4, top: 0, width: 1, height: 1, label: 'R' },
      { left: 5, top: 0, width: 1, height: 1, label: 'T' },
      { left: 6, top: 0, width: 1, height: 1, label: 'Y' },
      { left: 7, top: 0, width: 1, height: 1, label: 'U' },
      { left: 8, top: 0, width: 1, height: 1, label: 'I' },
      { left: 9, top: 0, width: 1, height: 1, label: 'O' },
      { left: 10, top: 0, width: 1, height: 1, label: 'P' },
      { left: 11, top: 0, width: 1, height: 1, label: '⌫' },
      { left: 0, top: 1, width: 1.25, height: 1, label: '⇥' },
      { left: 1.25, top: 1, width: 1, height: 1, label: 'A' },
      { left: 2.25, top: 1, width: 1, height: 1, label: 'S' },
      { left: 3.25, top: 1, width: 1, height: 1, label: 'D' },
      { left: 4.25, top: 1, width: 1, height: 1, label: 'F' },
      { left: 5.25, top: 1, width: 1, height: 1, label: 'G' },
      { left: 6.25, top: 1, width: 1, height: 1, label: 'H' },
      { left: 7.25, top: 1, width: 1, height: 1, label: 'J' },
      { left: 8.25, top: 1, width: 1, height: 1, label: 'K' },
      { left: 9.25, top: 1, width: 1, height: 1, label: 'L' },
      { left: 10.25, top: 1, width: 1.75, height: 1, label: '↩' },
      { left: 0, top: 2, width: 1.75, height: 1, label: '⇧' },
      { left: 1.75, top: 2, width: 1, height: 1, label: 'Z' },
      { left: 2.75, top: 2, width: 1, height: 1, label: 'X' },
      { left: 3.75, top: 2, width: 1, height: 1, label: 'C' },
      { left: 4.75, top: 2, width: 1, height: 1, label: 'V' },
      { left: 5.75, top: 2, width: 1, height: 1, label: 'B' },
      { left: 6.75, top: 2, width: 1, height: 1, label: 'N' },
      { left: 7.75, top: 2, width: 1, height: 1, label: 'M' },
      { left: 8.75, top: 2, width: 1, height: 1, label: '⇪' },
      { left: 9.75, top: 2, width: 1, height: 1, label: '▲' },
      { left: 10.75, top: 2, width: 1.25, height: 1, label: '⇧' },
      { left: 0, top: 3, width: 1.25, height: 1, label: '⌃' },
      { left: 1.25, top: 3, width: 1, height: 1, label: '⌥' },
      { left: 2.25, top: 3, width: 1.25, height: 1, label: '⌘' },
      { left: 3.5, top: 3, width: 3, height: 1, label: '' },
      { left: 6.5, top: 3, width: 1, height: 1, label: 'Fn1' },
      { left: 7.5, top: 3, width: 1, height: 1, label: 'Fn2' },
      { left: 8.5, top: 3, width: 1.25, height: 1, label: '◀' },
      { left: 9.75, top: 3, width: 1, height: 1, label: '▼' },
      { left: 10.75, top: 3, width: 1.25, height: 1, label: '▶' },
    ],
  },
  gh60: {
    rows: 5,
    cols: 15,
    rects: [
      { left: 0, top: 0, width: 1, height: 1, label: 'Esc' },
      { left: 1, top: 0, width: 1, height: 1, label: '1' },
      { left: 2, top: 0, width: 1, height: 1, label: '2' },
      { left: 3, top: 0, width: 1, height: 1, label: '3' },
      { left: 4, top: 0, width: 1, height: 1, label: '4' },
      { left: 5, top: 0, width: 1, height: 1, label: '5' },
      { left: 6, top: 0, width: 1, height: 1, label: '6' },
      { left: 7, top: 0, width: 1, height: 1, label: '7' },
      { left: 8, top: 0, width: 1, height: 1, label: '8' },
      { left: 9, top: 0, width: 1, height: 1, label: '9' },
      { left: 10, top: 0, width: 1, height: 1, label: '0' },
      { left: 11, top: 0, width: 1, height: 1, label: '-' },
      { left: 12, top: 0, width: 1, height: 1, label: '=' },
      { left: 13, top: 0, width: 2, height: 1, label: 'Backspace' },
      { left: 0, top: 1, width: 1.5, height: 1, label: 'Tab' },
      { left: 1.5, top: 1, width: 1, height: 1, label: 'Q' },
      { left: 2.5, top: 1, width: 1, height: 1, label: 'W' },
      { left: 3.5, top: 1, width: 1, height: 1, label: 'E' },
      { left: 4.5, top: 1, width: 1, height: 1, label: 'R' },
      { left: 5.5, top: 1, width: 1, height: 1, label: 'T' },
      { left: 6.5, top: 1, width: 1, height: 1, label: 'Y' },
      { left: 7.5, top: 1, width: 1, height: 1, label: 'U' },
      { left: 8.5, top: 1, width: 1, height: 1, label: 'I' },
      { left: 9.5, top: 1, width: 1, height: 1, label: 'O' },
      { left: 10.5, top: 1, width: 1, height: 1, label: 'P' },
      { left: 11.5, top: 1, width: 1, height: 1, label: '[' },
      { left: 12.5, top: 1, width: 1, height: 1, label: ']' },
      { left: 13.5, top: 1, width: 1.5, height: 1, label: '\\' },
      { left: 0, top: 2, width: 1.75, height: 1, label: 'Caps Lock' },
      { left: 1.75, top: 2, width: 1, height: 1, label: 'A' },
      { left: 2.75, top: 2, width: 1, height: 1, label: 'S' },
      { left: 3.75, top: 2, width: 1, height: 1, label: 'D' },
      { left: 4.75, top: 2, width: 1, height: 1, label: 'F' },
      { left: 5.75, top: 2, width: 1, height: 1, label: 'G' },
      { left: 6.75, top: 2, width: 1, height: 1, label: 'H' },
      { left: 7.75, top: 2, width: 1, height: 1, label: 'J' },
      { left: 8.75, top: 2, width: 1, height: 1, label: 'K' },
      { left: 9.75, top: 2, width: 1, height: 1, label: 'L' },
      { left: 10.75, top: 2, width: 1, height: 1, label: ';' },
      { left: 11.75, top: 2, width: 1, height: 1, label: `'` },
      { left: 12.75, top: 2, width: 2.25, height: 1, label: 'Enter' },
      { left: 0, top: 3, width: 2.25, height: 1, label: 'Shift' },
      { left: 2.25, top: 3, width: 1, height: 1, label: 'Z' },
      { left: 3.25, top: 3, width: 1, height: 1, label: 'X' },
      { left: 4.25, top: 3, width: 1, height: 1, label: 'C' },
      { left: 5.25, top: 3, width: 1, height: 1, label: 'V' },
      { left: 6.25, top: 3, width: 1, height: 1, label: 'B' },
      { left: 7.25, top: 3, width: 1, height: 1, label: 'N' },
      { left: 8.25, top: 3, width: 1, height: 1, label: 'M' },
      { left: 9.25, top: 3, width: 1, height: 1, label: ',' },
      { left: 10.25, top: 3, width: 1, height: 1, label: '.' },
      { left: 11.25, top: 3, width: 1, height: 1, label: '/' },
      { left: 12.25, top: 3, width: 2.75, height: 1, label: 'Shift' },
      { left: 0, top: 4, width: 1.25, height: 1, label: 'Ctrl' },
      { left: 1.25, top: 4, width: 1.25, height: 1, label: 'Win' },
      { left: 2.5, top: 4, width: 1.25, height: 1, label: 'Alt' },
      { left: 3.75, top: 4, width: 6.25, height: 1, label: '' },
      { left: 10, top: 4, width: 1.25, height: 1, label: 'Alt' },
      { left: 11.25, top: 4, width: 1.25, height: 1, label: 'Win' },
      { left: 12.5, top: 4, width: 1.25, height: 1, label: 'Menu' },
      { left: 13.75, top: 4, width: 1.25, height: 1, label: 'Ctrl' },
    ],
  },
  ls64: {
    rows: 5,
    cols: 15,
    rects: [
      { left: 0, top: 0, width: 1, height: 1, label: 'Esc' },
      { left: 1, top: 0, width: 1, height: 1, label: '1' },
      { left: 2, top: 0, width: 1, height: 1, label: '2' },
      { left: 3, top: 0, width: 1, height: 1, label: '3' },
      { left: 4, top: 0, width: 1, height: 1, label: '4' },
      { left: 5, top: 0, width: 1, height: 1, label: '5' },
      { left: 6, top: 0, width: 1, height: 1, label: '6' },
      { left: 7, top: 0, width: 1, height: 1, label: '7' },
      { left: 8, top: 0, width: 1, height: 1, label: '8' },
      { left: 9, top: 0, width: 1, height: 1, label: '9' },
      { left: 10, top: 0, width: 1, height: 1, label: '0' },
      { left: 11, top: 0, width: 1, height: 1, label: '-' },
      { left: 12, top: 0, width: 1, height: 1, label: '=' },
      { left: 13, top: 0, width: 2, height: 1, label: 'Backspace' },
      { left: 0, top: 1, width: 1.5, height: 1, label: 'Tab' },
      { left: 1.5, top: 1, width: 1, height: 1, label: 'Q' },
      { left: 2.5, top: 1, width: 1, height: 1, label: 'W' },
      { left: 3.5, top: 1, width: 1, height: 1, label: 'E' },
      { left: 4.5, top: 1, width: 1, height: 1, label: 'R' },
      { left: 5.5, top: 1, width: 1, height: 1, label: 'T' },
      { left: 6.5, top: 1, width: 1, height: 1, label: 'Y' },
      { left: 7.5, top: 1, width: 1, height: 1, label: 'U' },
      { left: 8.5, top: 1, width: 1, height: 1, label: 'I' },
      { left: 9.5, top: 1, width: 1, height: 1, label: 'O' },
      { left: 10.5, top: 1, width: 1, height: 1, label: 'P' },
      { left: 11.5, top: 1, width: 1, height: 1, label: '[' },
      { left: 12.5, top: 1, width: 1, height: 1, label: ']' },
      { left: 13.5, top: 1, width: 1.5, height: 1, label: '\\' },
      { left: 0, top: 2, width: 1.75, height: 1, label: 'Caps Lock' },
      { left: 1.75, top: 2, width: 1, height: 1, label: 'A' },
      { left: 2.75, top: 2, width: 1, height: 1, label: 'S' },
      { left: 3.75, top: 2, width: 1, height: 1, label: 'D' },
      { left: 4.75, top: 2, width: 1, height: 1, label: 'F' },
      { left: 5.75, top: 2, width: 1, height: 1, label: 'G' },
      { left: 6.75, top: 2, width: 1, height: 1, label: 'H' },
      { left: 7.75, top: 2, width: 1, height: 1, label: 'J' },
      { left: 8.75, top: 2, width: 1, height: 1, label: 'K' },
      { left: 9.75, top: 2, width: 1, height: 1, label: 'L' },
      { left: 10.75, top: 2, width: 1, height: 1, label: ';' },
      { left: 11.75, top: 2, width: 1, height: 1, label: `'` },
      { left: 12.75, top: 2, width: 2.25, height: 1, label: 'Enter' },
      { left: 0, top: 3, width: 2, height: 1, label: 'Shift' },
      { left: 2, top: 3, width: 1, height: 1, label: 'Z' },
      { left: 3, top: 3, width: 1, height: 1, label: 'X' },
      { left: 4, top: 3, width: 1, height: 1, label: 'C' },
      { left: 5, top: 3, width: 1, height: 1, label: 'V' },
      { left: 6, top: 3, width: 1, height: 1, label: 'B' },
      { left: 7, top: 3, width: 1, height: 1, label: 'N' },
      { left: 8, top: 3, width: 1, height: 1, label: 'M' },
      { left: 9, top: 3, width: 1, height: 1, label: ',' },
      { left: 10, top: 3, width: 1, height: 1, label: '.' },
      { left: 11, top: 3, width: 1, height: 1, label: '/' },
      { left: 12, top: 3, width: 1, height: 1, label: 'Shift' },
      { left: 13, top: 3, width: 1, height: 1, label: '▲' },
      { left: 14, top: 3, width: 1, height: 1, label: 'Delete' },
      { left: 0, top: 4, width: 1.25, height: 1, label: 'Ctrl' },
      { left: 1.25, top: 4, width: 1.25, height: 1, label: 'Win' },
      { left: 2.5, top: 4, width: 1.25, height: 1, label: 'Alt' },
      { left: 3.75, top: 4, width: 6.25, height: 1, label: '' },
      { left: 10, top: 4, width: 1, height: 1, label: 'Alt' },
      { left: 11, top: 4, width: 1, height: 1, label: 'Win' },
      { left: 12, top: 4, width: 1, height: 1, label: '◀' },
      { left: 13, top: 4, width: 1, height: 1, label: '▼' },
      { left: 14, top: 4, width: 1, height: 1, label: '▶' },
    ],
  },
  ansi104: {
    rows: 6.5,
    cols: 22.5,
    rects: [
      { left: 0, top: 0, width: 1, height: 1, label: 'Esc' },
      { left: 2, top: 0, width: 1, height: 1, label: 'F1' },
      { left: 3, top: 0, width: 1, height: 1, label: 'F2' },
      { left: 4, top: 0, width: 1, height: 1, label: 'F3' },
      { left: 5, top: 0, width: 1, height: 1, label: 'F4' },
      { left: 6.5, top: 0, width: 1, height: 1, label: 'F5' },
      { left: 7.5, top: 0, width: 1, height: 1, label: 'F6' },
      { left: 8.5, top: 0, width: 1, height: 1, label: 'F7' },
      { left: 9.5, top: 0, width: 1, height: 1, label: 'F8' },
      { left: 11, top: 0, width: 1, height: 1, label: 'F9' },
      { left: 12, top: 0, width: 1, height: 1, label: 'F10' },
      { left: 13, top: 0, width: 1, height: 1, label: 'F11' },
      { left: 14, top: 0, width: 1, height: 1, label: 'F12' },
      { left: 15.25, top: 0, width: 1, height: 1, label: 'PrtSc' },
      { left: 16.25, top: 0, width: 1, height: 1, label: 'ScrLck' },
      { left: 17.25, top: 0, width: 1, height: 1, label: 'Pause' },
      { left: 0, top: 1.5, width: 1, height: 1, label: '`' },
      { left: 1, top: 1.5, width: 1, height: 1, label: '1' },
      { left: 2, top: 1.5, width: 1, height: 1, label: '2' },
      { left: 3, top: 1.5, width: 1, height: 1, label: '3' },
      { left: 4, top: 1.5, width: 1, height: 1, label: '4' },
      { left: 5, top: 1.5, width: 1, height: 1, label: '5' },
      { left: 6, top: 1.5, width: 1, height: 1, label: '6' },
      { left: 7, top: 1.5, width: 1, height: 1, label: '7' },
      { left: 8, top: 1.5, width: 1, height: 1, label: '8' },
      { left: 9, top: 1.5, width: 1, height: 1, label: '9' },
      { left: 10, top: 1.5, width: 1, height: 1, label: '0' },
      { left: 11, top: 1.5, width: 1, height: 1, label: '-' },
      { left: 12, top: 1.5, width: 1, height: 1, label: '=' },
      { left: 13, top: 1.5, width: 2, height: 1, label: 'Backspace' },
      { left: 15.25, top: 1.5, width: 1, height: 1, label: 'Insert' },
      { left: 16.25, top: 1.5, width: 1, height: 1, label: 'Home' },
      { left: 17.25, top: 1.5, width: 1, height: 1, label: 'PgUp' },
      { left: 18.5, top: 1.5, width: 1, height: 1, label: 'Num' },
      { left: 19.5, top: 1.5, width: 1, height: 1, label: '/' },
      { left: 20.5, top: 1.5, width: 1, height: 1, label: '*' },
      { left: 21.5, top: 1.5, width: 1, height: 1, label: '-' },
      { left: 0, top: 2.5, width: 1.5, height: 1, label: 'Tab' },
      { left: 1.5, top: 2.5, width: 1, height: 1, label: 'Q' },
      { left: 2.5, top: 2.5, width: 1, height: 1, label: 'W' },
      { left: 3.5, top: 2.5, width: 1, height: 1, label: 'E' },
      { left: 4.5, top: 2.5, width: 1, height: 1, label: 'R' },
      { left: 5.5, top: 2.5, width: 1, height: 1, label: 'T' },
      { left: 6.5, top: 2.5, width: 1, height: 1, label: 'Y' },
      { left: 7.5, top: 2.5, width: 1, height: 1, label: 'U' },
      { left: 8.5, top: 2.5, width: 1, height: 1, label: 'I' },
      { left: 9.5, top: 2.5, width: 1, height: 1, label: 'O' },
      { left: 10.5, top: 2.5, width: 1, height: 1, label: 'P' },
      { left: 11.5, top: 2.5, width: 1, height: 1, label: '[' },
      { left: 12.5, top: 2.5, width: 1, height: 1, label: ']' },
      { left: 13.5, top: 2.5, width: 1.5, height: 1, label: '\\' },
      { left: 15.25, top: 2.5, width: 1, height: 1, label: 'Delete' },
      { left: 16.25, top: 2.5, width: 1, height: 1, label: 'End' },
      { left: 17.25, top: 2.5, width: 1, height: 1, label: 'PgDn' },
      { left: 18.5, top: 2.5, width: 1, height: 1, label: '7' },
      { left: 19.5, top: 2.5, width: 1, height: 1, label: '8' },
      { left: 20.5, top: 2.5, width: 1, height: 1, label: '9' },
      { left: 21.5, top: 2.5, width: 1, height: 2, label: '+' },
      { left: 0, top: 3.5, width: 1.75, height: 1, label: 'Caps Lock' },
      { left: 1.75, top: 3.5, width: 1, height: 1, label: 'A' },
      { left: 2.75, top: 3.5, width: 1, height: 1, label: 'S' },
      { left: 3.75, top: 3.5, width: 1, height: 1, label: 'D' },
      { left: 4.75, top: 3.5, width: 1, height: 1, label: 'F' },
      { left: 5.75, top: 3.5, width: 1, height: 1, label: 'G' },
      { left: 6.75, top: 3.5, width: 1, height: 1, label: 'H' },
      { left: 7.75, top: 3.5, width: 1, height: 1, label: 'J' },
      { left: 8.75, top: 3.5, width: 1, height: 1, label: 'K' },
      { left: 9.75, top: 3.5, width: 1, height: 1, label: 'L' },
      { left: 10.75, top: 3.5, width: 1, height: 1, label: ';' },
      { left: 11.75, top: 3.5, width: 1, height: 1, label: `'` },
      { left: 12.75, top: 3.5, width: 2.25, height: 1, label: 'Enter' },
      { left: 18.5, top: 3.5, width: 1, height: 1, label: '4' },
      { left: 19.5, top: 3.5, width: 1, height: 1, label: '5' },
      { left: 20.5, top: 3.5, width: 1, height: 1, label: '6' },
      { left: 0, top: 4.5, width: 2.25, height: 1, label: 'Shift' },
      { left: 2.25, top: 4.5, width: 1, height: 1, label: 'Z' },
      { left: 3.25, top: 4.5, width: 1, height: 1, label: 'X' },
      { left: 4.25, top: 4.5, width: 1, height: 1, label: 'C' },
      { left: 5.25, top: 4.5, width: 1, height: 1, label: 'V' },
      { left: 6.25, top: 4.5, width: 1, height: 1, label: 'B' },
      { left: 7.25, top: 4.5, width: 1, height: 1, label: 'N' },
      { left: 8.25, top: 4.5, width: 1, height: 1, label: 'M' },
      { left: 9.25, top: 4.5, width: 1, height: 1, label: ',' },
      { left: 10.25, top: 4.5, width: 1, height: 1, label: '.' },
      { left: 11.25, top: 4.5, width: 1, height: 1, label: '/' },
      { left: 12.25, top: 4.5, width: 2.75, height: 1, label: 'Shift' },
      { left: 16.25, top: 4.5, width: 1, height: 1, label: '▲' },
      { left: 18.5, top: 4.5, width: 1, height: 1, label: '1' },
      { left: 19.5, top: 4.5, width: 1, height: 1, label: '2' },
      { left: 20.5, top: 4.5, width: 1, height: 1, label: '3' },
      { left: 21.5, top: 4.5, width: 1, height: 2, label: 'Enter' },
      { left: 0, top: 5.5, width: 1.25, height: 1, label: 'Ctrl' },
      { left: 1.25, top: 5.5, width: 1.25, height: 1, label: 'Win' },
      { left: 2.5, top: 5.5, width: 1.25, height: 1, label: 'Alt' },
      { left: 3.75, top: 5.5, width: 6.25, height: 1, label: '' },
      { left: 10, top: 5.5, width: 1.25, height: 1, label: 'Alt' },
      { left: 11.25, top: 5.5, width: 1.25, height: 1, label: 'Win' },
      { left: 12.5, top: 5.5, width: 1.25, height: 1, label: 'Menu' },
      { left: 13.75, top: 5.5, width: 1.25, height: 1, label: 'Ctrl' },
      { left: 15.25, top: 5.5, width: 1, height: 1, label: '◀' },
      { left: 16.25, top: 5.5, width: 1, height: 1, label: '▼' },
      { left: 17.25, top: 5.5, width: 1, height: 1, label: '▶' },
      { left: 18.5, top: 5.5, width: 2, height: 1, label: '0' },
      { left: 20.5, top: 5.5, width: 1, height: 1, label: '.' },
    ],
  },
}
